"use es6";

import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { gapi } from "gapi-script";
import jwt_decode from "jwt-decode";
import Button from "../Buttons/Button";
import H1 from "../Text/H1";

import chevron from "../../graphics/icons/chevron.svg";
import H3 from "../Text/H3";
import H2 from "../Text/H2";
import P from "../Text/P";
import HR from "../Text/HR";
import Viewport from "./Viewport";

const UploadViewport = ({
  isDesktop = null,
  children = "[insert text]",
  credentials = null,
  setCredentials = {},
  updateCredentials = {},
  language = null,
  translation = null,
  uploadViewportVisible = false,
  setUploadViewportVisible = {},
  image = {},
  setImage = {},
  selectedFile = null,
  setSelectedFile = {},
}) => {
  const navigate = useNavigate();

  const requestConfig = {
    headers: {
      "x-api-key": process.env.REACT_APP_API_KEY,
    },
  };

  return (
    <Viewport
      isDesktop={isDesktop}
      heading={translation.navigation.upload_image}
      viewportVisible={uploadViewportVisible}
      setViewportVisible={setUploadViewportVisible}
    >
      <div style={{ textAlign: "center", maxHeight: 550, overflowY: "scroll" }}>
        <label
          id="browse-files-label"
          for="browse-files"
          style={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              position: "relative",
              margin: "auto",
              padding: 5,
              height: "fit-content",
            }}
          >
            <P style={{ fontWeight: 600, fontSize: 16 }}>
              {translation.button.browse}
            </P>
          </div>
        </label>

        <input
          id="browse-files"
          type="file"
          accept="image/*"
          onChange={(e) => setSelectedFile(e.target.files[0])}
        />

        {!!selectedFile ? (
          <div>
            <img
              id="blah"
              src={URL.createObjectURL(selectedFile) || "#"}
              style={{
                maxHeight: 300,
                maxWidth: 355,
                borderRadius: 8,
                margin: 15,
                objectFit: "cover",
              }}
            />
            <Button
              type="solid"
              style={{ width: 315, margin: "auto" }}
              onClick={() => {
                setImage(URL.createObjectURL(selectedFile));
                setUploadViewportVisible(false);
              }}
            >
              {translation.button.select}
            </Button>
          </div>
        ) : (
          <P style={{ margin: 50 }}>
            {translation.miscellaneous.preview_string}
          </P>
        )}
      </div>
    </Viewport>
  );
};

export default UploadViewport;
